// import React, { useState, useRef, useEffect } from "react";
// import { createPortal } from "react-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { Button } from "..";

// const fontSizeClasses = {
//   xs: "text-[12px]",
//   "xs-sm": "text-[14px]",
//   sm: "text-[16px]",
//   md: "text-[18px]",
//   lg: "text-[20px]",
//   xl: "text-[22px]",
// };

// const borderSizeClasses = {
//   xs: "border-2",
//   "xs-sm": "border-2",
//   sm: "border-[3px]",
//   md: "border-2",
//   lg: "border-2",
//   xl: "border-4",
// };

// const borderColorClasses = {
//   contained: {
//     primary: "border-primary-700",
//     warning: "border-warning-700",
//     success: "border-success-700",
//     danger: "border-danger-700",
//     black: "border-gray-200",
//     white: "border-gray-700",
//   },
//   outlined: {
//     primary: "border-primary-200",
//     warning: "border-warning-200",
//     success: "border-success-200",
//     danger: "border-danger-200",
//     black: "border-gray-200",
//     white: "border-gray-300",
//   },
//   text: {
//     primary: "border-primary-200",
//     warning: "border-warning-200",
//     success: "border-success-200",
//     danger: "border-danger-200",
//     black: "border-gray-300",
//     white: "border-gray-300",
//   },
// };

// const tooltipVariants = {
//   contained: {
//     primary: "bg-primary text-white",
//     warning: "bg-warning-500 text-white",
//     success: "bg-success-500 text-white",
//     danger: "bg-danger-500 text-white",
//     black: "bg-black text-white",
//     white: "bg-white text-black",
//   },
//   text: {
//     primary: "bg-white text-primary",
//     warning: "bg-white text-warning-500",
//     success: "bg-white text-success-500",
//     danger: "bg-white text-danger-500",
//     black: "bg-white text-black",
//     white: "bg-black text-white",
//   },
//   outlined: {
//     primary: "bg-primary-50  text-primary",
//     warning: "bg-warning-50  text-warning-500",
//     success: "bg-success-50  text-success-500",
//     danger: "bg-danger-50  text-danger-500",
//     black: "bg-gray-100  text-black",
//     white: "bg-gray-500  text-white",
//   },
// };

// const SmartTooltip = ({
//   children,
//   description,
//   size = "xs", // xs, sm, md, lg, xl
//   color = "black", // primary, warning, success, danger, black, white
//   tooltipPosition = "right", // top, bottom, left, right
//   variant = "contained", // outlined, text
//   delay = 0,
//   offset = 18,
//   noicon = false,
//   noTooltip = false,
//   portal = false,
// }) => {
//   const [visible, setVisible] = useState(false);
//   const [position, setPosition] = useState(tooltipPosition);
//   const [coords, setCoords] = useState({ top: 0, left: 0 });
//   const tooltipRef = useRef(null);
//   const childRef = useRef(null);
//   const hoverTimeoutRef = useRef(null);

//   const handleMouseEnter = () => {
//     if (hoverTimeoutRef.current) {
//       clearTimeout(hoverTimeoutRef.current);
//     }
//     hoverTimeoutRef.current = setTimeout(() => {
//       setVisible(true);
//       hoverTimeoutRef.current = null;
//     }, delay);
//   };

//   const handleMouseLeave = () => {
//     if (hoverTimeoutRef.current) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = null;
//     }
//     setVisible(false);
//   };

//   useEffect(() => {
//     return () => {
//       if (hoverTimeoutRef.current) {
//         clearTimeout(hoverTimeoutRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (!visible) return;
//     const tooltip = tooltipRef.current;
//     const child = childRef.current;
//     if (!tooltip || !child) return;

//     const tooltipRect = tooltip.getBoundingClientRect();
//     const childRect = child.getBoundingClientRect();
//     const screenWidth = window.innerWidth;
//     const screenHeight = window.innerHeight;

//     let newPosition = tooltipPosition;

//     if (
//       tooltipPosition === "right" &&
//       childRect.right + tooltipRect.width + offset > screenWidth
//     ) {
//       newPosition = "left";
//     } else if (
//       tooltipPosition === "left" &&
//       childRect.left - tooltipRect.width - offset < 0
//     ) {
//       newPosition = "right";
//     } else if (
//       tooltipPosition === "top" &&
//       childRect.top - tooltipRect.height - offset < 0
//     ) {
//       newPosition = "bottom";
//     } else if (
//       tooltipPosition === "bottom" &&
//       childRect.bottom + tooltipRect.height + offset > screenHeight
//     ) {
//       newPosition = "top";
//     }

//     setPosition(newPosition);
//   }, [visible, tooltipPosition, offset]);

//   useEffect(() => {
//     if (!visible || !portal) return;

//     const compute = () => {
//       const tooltip = tooltipRef.current;
//       const child = childRef.current;
//       if (!tooltip || !child) return;

//       const tooltipRect = tooltip.getBoundingClientRect();
//       const childRect = child.getBoundingClientRect();
//       const screenWidth = window.innerWidth;
//       const screenHeight = window.innerHeight;

//       const pad = 8;

//       const getCoords = (pos) => {
//         if (pos === "top") {
//           return {
//             top: childRect.top - tooltipRect.height - offset,
//             left: childRect.left + childRect.width / 2 - tooltipRect.width / 2,
//           };
//         }
//         if (pos === "bottom") {
//           return {
//             top: childRect.bottom + offset,
//             left: childRect.left + childRect.width / 2 - tooltipRect.width / 2,
//           };
//         }
//         if (pos === "left") {
//           return {
//             top: childRect.top + childRect.height / 2 - tooltipRect.height / 2,
//             left: childRect.left - tooltipRect.width - offset,
//           };
//         }
//         return {
//           top: childRect.top + childRect.height / 2 - tooltipRect.height / 2,
//           left: childRect.right + offset,
//         };
//       };

//       let { top, left } = getCoords(position);

//       top = Math.max(
//         pad,
//         Math.min(top, screenHeight - tooltipRect.height - pad),
//       );
//       left = Math.max(
//         pad,
//         Math.min(left, screenWidth - tooltipRect.width - pad),
//       );

//       setCoords({ top, left });
//     };

//     compute();
//     window.addEventListener("resize", compute);
//     window.addEventListener("scroll", compute, true);
//     return () => {
//       window.removeEventListener("resize", compute);
//       window.removeEventListener("scroll", compute, true);
//     };
//   }, [visible, portal, position, offset]);

//   return (
//     <div className={`flex items-center gap-1`}>
//       {!noicon && children}
//       <div className="relative inline-block" ref={childRef}>
//         {noicon ? (
//           <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
//             {children}
//           </div>
//         ) : (
//           <Button
//             type="icon"
//             size={size === "lg" || size === "xl" ? size : "md"}
//             icon={"info"}
//             color={color}
//             variant="text"
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//             disabled={noTooltip}
//           />
//         )}
//         {portal ? (
//           createPortal(
//             <AnimatePresence>
//               {visible && !noTooltip && (
//                 <motion.div
//                   ref={tooltipRef}
//                   initial={{ opacity: 0, scale: 0.98 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.98 }}
//                   transition={{ duration: 0.15 }}
//                   className={`fixed whitespace-nowrap px-4 py-3 rounded-md z-[9999] leading-none
//             ${tooltipVariants[variant][color]}
//             ${fontSizeClasses[size]}
//             ${borderSizeClasses[size]}
//             ${borderColorClasses[variant][color]}
//           `}
//                   style={{
//                     top: coords.top,
//                     left: coords.left,
//                   }}
//                 >
//                   {description}
//                 </motion.div>
//               )}
//             </AnimatePresence>,
//             document.body,
//           )
//         ) : (
//           <AnimatePresence>
//             {visible && !noTooltip && (
//               <motion.div
//                 ref={tooltipRef}
//                 initial={{ opacity: 0, scale: 0.8 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.8 }}
//                 transition={{ duration: 0.2 }}
//                 className={`absolute whitespace-nowrap px-4 py-3 rounded-md z-50  leading-none
//             ${tooltipVariants[variant][color]}
//             ${fontSizeClasses[size]}
//             ${borderSizeClasses[size]}
//             ${borderColorClasses[variant][color]}
//             ${
//               position === "top"
//                 ? "bottom-full -left-1/3 transform -translate-x-1/3 mb-2"
//                 : ""
//             }
//             ${
//               position === "bottom"
//                 ? "top-full -left-1/3 transform -translate-x-1/3 mt-2"
//                 : ""
//             }
//             ${
//               position === "left"
//                 ? "right-full top-1/2 transform -translate-y-1/2 -translate-x-2 mr-2"
//                 : ""
//             }
//               ${
//                 position === "right"
//                   ? "left-full top-1/2 transform -translate-y-1/2 translate-x-2 ml-2"
//                   : ""
//               }
//           `}
//               >
//                 {description}
//               </motion.div>
//             )}
//           </AnimatePresence>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SmartTooltip;

import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "..";

const fontSizeClasses = {
  xs: "text-[12px]",
  "xs-sm": "text-[14px]",
  sm: "text-[16px]",
  md: "text-[18px]",
  lg: "text-[20px]",
  xl: "text-[22px]",
};

const borderSizeClasses = {
  xs: "border-2",
  "xs-sm": "border-2",
  sm: "border-[3px]",
  md: "border-2",
  lg: "border-2",
  xl: "border-4",
};

const borderColorClasses = {
  contained: {
    primary: "border-primary-700",
    warning: "border-warning-700",
    success: "border-success-700",
    danger: "border-danger-700",
    black: "border-gray-200",
    white: "border-gray-700",
  },
  outlined: {
    primary: "border-primary-200",
    warning: "border-warning-200",
    success: "border-success-200",
    danger: "border-danger-200",
    black: "border-gray-200",
    white: "border-gray-300",
  },
  text: {
    primary: "border-primary-200",
    warning: "border-warning-200",
    success: "border-success-200",
    danger: "border-danger-200",
    black: "border-gray-300",
    white: "border-gray-300",
  },
};

const tooltipVariants = {
  contained: {
    primary: "bg-primary text-white",
    warning: "bg-warning-500 text-white",
    success: "bg-success-500 text-white",
    danger: "bg-danger-500 text-white",
    black: "bg-black text-white",
    white: "bg-white text-black",
  },
  text: {
    primary: "bg-white text-primary",
    warning: "bg-white text-warning-500",
    success: "bg-white text-success-500",
    danger: "bg-white text-danger-500",
    black: "bg-white text-black",
    white: "bg-black text-white",
  },
  outlined: {
    primary: "bg-primary-50  text-primary",
    warning: "bg-warning-50  text-warning-500",
    success: "bg-success-50  text-success-500",
    danger: "bg-danger-50  text-danger-500",
    black: "bg-gray-100  text-black",
    white: "bg-gray-500  text-white",
  },
};

const clamp = (value, min, max) => {
  if (max < min) return min;
  return Math.max(min, Math.min(value, max));
};

const getPlacementOrder = (preferred) => {
  if (preferred === "top") return ["top", "bottom", "right", "left"];
  if (preferred === "bottom") return ["bottom", "top", "right", "left"];
  if (preferred === "left") return ["left", "right", "top", "bottom"];
  return ["right", "left", "top", "bottom"];
};

const isOverflowClipping = (value) =>
  value === "hidden" ||
  value === "auto" ||
  value === "scroll" ||
  value === "clip";

const getStickyTopOffset = (boundaryEl, boundaryRect) => {
  if (!boundaryEl) return 0;

  const candidates = [
    ...boundaryEl.querySelectorAll("thead"),
    ...boundaryEl.querySelectorAll(".sticky"),
  ];

  let maxOffset = 0;
  for (const el of candidates) {
    const cs = window.getComputedStyle(el);
    if (cs.position !== "sticky") continue;
    const top = Number.parseFloat(cs.top || "0");
    if (!Number.isFinite(top) || top > 1) continue;

    const r = el.getBoundingClientRect();
    if (r.height <= 0) continue;
    if (r.top > boundaryRect.top + 2) continue;

    maxOffset = Math.max(maxOffset, r.bottom - boundaryRect.top);
  }

  return maxOffset;
};

const SmartTooltip = ({
  children,
  description,
  size = "xs", // xs, sm, md, lg, xl
  color = "black", // primary, warning, success, danger, black, white
  tooltipPosition = "right", // top, bottom, left, right
  variant = "contained", // outlined, text
  delay = 0,
  offset = 18,
  noicon = false,
  noTooltip = false,
  portal = false,
}) => {
  const [visible, setVisible] = useState(false);
  const tooltipRef = useRef(null);
  const childRef = useRef(null);
  const hoverTimeoutRef = useRef(null);
  const rafRef = useRef(null);
  const resizeObserversRef = useRef({ anchor: null, tooltip: null });
  const autoWrapRef = useRef(false);
  const autoHeightRef = useRef(false);
  const lastAppliedRef = useRef({
    top: null,
    left: null,
    position: null,
    maxWidth: null,
    maxHeight: null,
    whiteSpace: null,
    wordBreak: null,
    overflowY: null,
  });

  const handleMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    hoverTimeoutRef.current = setTimeout(() => {
      setVisible(true);
      hoverTimeoutRef.current = null;
    }, delay);
  };

  const handleMouseLeave = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setVisible(false);
  };

  useEffect(() => {
    if (visible) return;
    autoWrapRef.current = false;
    autoHeightRef.current = false;
    lastAppliedRef.current = {
      top: null,
      left: null,
      position: null,
      maxWidth: null,
      maxHeight: null,
      whiteSpace: null,
      wordBreak: null,
      overflowY: null,
    };
  }, [visible]);

  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
      if (resizeObserversRef.current.anchor) {
        resizeObserversRef.current.anchor.disconnect();
        resizeObserversRef.current.anchor = null;
      }
      if (resizeObserversRef.current.tooltip) {
        resizeObserversRef.current.tooltip.disconnect();
        resizeObserversRef.current.tooltip = null;
      }
    };
  }, []);

  const applyStyle = (el, next) => {
    const last = lastAppliedRef.current;
    if (last.position !== next.position) {
      el.style.position = next.position;
      last.position = next.position;
    }
    if (last.top !== next.top) {
      el.style.top = `${next.top}px`;
      last.top = next.top;
    }
    if (last.left !== next.left) {
      el.style.left = `${next.left}px`;
      last.left = next.left;
    }
    if (last.maxWidth !== next.maxWidth) {
      el.style.maxWidth = next.maxWidth ?? "";
      last.maxWidth = next.maxWidth;
    }
    if (last.maxHeight !== next.maxHeight) {
      el.style.maxHeight = next.maxHeight ?? "";
      last.maxHeight = next.maxHeight;
    }
    if (last.whiteSpace !== next.whiteSpace) {
      el.style.whiteSpace = next.whiteSpace ?? "";
      last.whiteSpace = next.whiteSpace;
    }
    if (last.wordBreak !== next.wordBreak) {
      el.style.wordBreak = next.wordBreak ?? "";
      last.wordBreak = next.wordBreak;
    }
    if (last.overflowY !== next.overflowY) {
      el.style.overflowY = next.overflowY ?? "";
      last.overflowY = next.overflowY;
    }
  };

  const computePosition = () => {
    const tooltipEl = tooltipRef.current;
    const anchorEl = childRef.current;
    if (!tooltipEl || !anchorEl) return;

    const pad = 8;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const anchorRect = anchorEl.getBoundingClientRect();
    const tooltipRect = tooltipEl.getBoundingClientRect();

    let boundaryRect = {
      top: 0,
      left: 0,
      right: viewportWidth,
      bottom: viewportHeight,
    };
    let boundaryEl = null;

    if (!portal) {
      let p = anchorEl.parentElement;
      while (p && p !== document.body) {
        const cs = window.getComputedStyle(p);
        const clipsX = isOverflowClipping(cs.overflowX);
        const clipsY = isOverflowClipping(cs.overflowY);
        if (clipsX || clipsY) {
          const r = p.getBoundingClientRect();
          const usableWidth = p.clientWidth || r.width;
          const usableHeight = p.clientHeight || r.height;
          boundaryEl = p;
          boundaryRect = {
            top: r.top,
            left: r.left,
            right: r.left + usableWidth,
            bottom: r.top + usableHeight,
          };
          break;
        }
        p = p.parentElement;
      }
    }

    const stickyTopOffset = getStickyTopOffset(boundaryEl, boundaryRect);
    const boundaryTop = boundaryRect.top + stickyTopOffset;

    const boundaryWidth = boundaryRect.right - boundaryRect.left;
    const boundaryHeight = boundaryRect.bottom - boundaryTop;
    const shouldAutoWrap =
      autoWrapRef.current || tooltipRect.width > boundaryWidth - pad * 2;
    if (shouldAutoWrap) autoWrapRef.current = true;
    const shouldAutoHeight =
      autoHeightRef.current || tooltipRect.height > boundaryHeight - pad * 2;
    if (shouldAutoHeight) autoHeightRef.current = true;

    const effectiveWidth = shouldAutoWrap
      ? Math.min(tooltipRect.width, Math.max(0, boundaryWidth - pad * 2))
      : tooltipRect.width;
    const effectiveHeight = shouldAutoHeight
      ? Math.min(tooltipRect.height, Math.max(0, boundaryHeight - pad * 2))
      : tooltipRect.height;

    const nextMaxWidth = shouldAutoWrap
      ? `${Math.max(0, Math.min(360, boundaryWidth - pad * 2))}px`
      : null;
    const nextWhiteSpace = shouldAutoWrap ? "normal" : null;
    const nextWordBreak = shouldAutoWrap ? "break-word" : null;
    const nextMaxHeight = shouldAutoHeight
      ? `${Math.max(0, boundaryHeight - pad * 2)}px`
      : null;
    const nextOverflowY = shouldAutoHeight ? "auto" : null;

    const placements = getPlacementOrder(tooltipPosition);

    const getCandidate = (pos) => {
      if (pos === "top") {
        return {
          top: anchorRect.top - effectiveHeight - offset,
          left: anchorRect.left + anchorRect.width / 2 - effectiveWidth / 2,
        };
      }
      if (pos === "bottom") {
        return {
          top: anchorRect.bottom + offset,
          left: anchorRect.left + anchorRect.width / 2 - effectiveWidth / 2,
        };
      }
      if (pos === "left") {
        return {
          top: anchorRect.top + anchorRect.height / 2 - effectiveHeight / 2,
          left: anchorRect.left - effectiveWidth - offset,
        };
      }
      return {
        top: anchorRect.top + anchorRect.height / 2 - effectiveHeight / 2,
        left: anchorRect.right + offset,
      };
    };

    const getOverflowScore = (candidate) => {
      const leftOverflow = Math.max(
        0,
        boundaryRect.left + pad - candidate.left,
      );
      const rightOverflow = Math.max(
        0,
        candidate.left + effectiveWidth - (boundaryRect.right - pad),
      );
      const topOverflow = Math.max(0, boundaryTop + pad - candidate.top);
      const bottomOverflow = Math.max(
        0,
        candidate.top + effectiveHeight - (boundaryRect.bottom - pad),
      );
      return leftOverflow + rightOverflow + topOverflow + bottomOverflow;
    };

    let best = {
      score: Number.POSITIVE_INFINITY,
      coords: getCandidate(placements[0]),
    };

    for (const pos of placements) {
      const candidate = getCandidate(pos);
      const score = getOverflowScore(candidate);
      if (score === 0) {
        best = { score, coords: candidate };
        break;
      }
      if (score < best.score) {
        best = { score, coords: candidate };
      }
    }

    const minLeft = boundaryRect.left + pad;
    const minTop = boundaryTop + pad;
    const maxLeft = boundaryRect.right - effectiveWidth - pad;
    const maxTop = boundaryRect.bottom - effectiveHeight - pad;

    const viewportTop = clamp(best.coords.top, minTop, maxTop);
    const viewportLeft = clamp(best.coords.left, minLeft, maxLeft);

    const nextPosition = portal ? "fixed" : "absolute";
    const nextTop = portal ? viewportTop : viewportTop - anchorRect.top;
    const nextLeft = portal ? viewportLeft : viewportLeft - anchorRect.left;

    applyStyle(tooltipEl, {
      position: nextPosition,
      top: nextTop,
      left: nextLeft,
      maxWidth: nextMaxWidth,
      maxHeight: nextMaxHeight,
      whiteSpace: nextWhiteSpace,
      wordBreak: nextWordBreak,
      overflowY: nextOverflowY,
    });
  };

  const scheduleCompute = () => {
    if (rafRef.current) return;
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      computePosition();
    });
  };

  useLayoutEffect(() => {
    if (!visible) return;
    scheduleCompute();
  }, [visible, tooltipPosition, offset, portal]);

  useEffect(() => {
    if (!visible) return;

    scheduleCompute();
    window.addEventListener("resize", scheduleCompute);
    window.addEventListener("scroll", scheduleCompute, true);

    if (typeof ResizeObserver !== "undefined") {
      const anchor = childRef.current;
      const tooltip = tooltipRef.current;

      if (anchor && !resizeObserversRef.current.anchor) {
        resizeObserversRef.current.anchor = new ResizeObserver(scheduleCompute);
        resizeObserversRef.current.anchor.observe(anchor);
      }
      if (tooltip && !resizeObserversRef.current.tooltip) {
        resizeObserversRef.current.tooltip = new ResizeObserver(
          scheduleCompute,
        );
        resizeObserversRef.current.tooltip.observe(tooltip);
      }
    }

    return () => {
      window.removeEventListener("resize", scheduleCompute);
      window.removeEventListener("scroll", scheduleCompute, true);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
      if (resizeObserversRef.current.anchor) {
        resizeObserversRef.current.anchor.disconnect();
        resizeObserversRef.current.anchor = null;
      }
      if (resizeObserversRef.current.tooltip) {
        resizeObserversRef.current.tooltip.disconnect();
        resizeObserversRef.current.tooltip = null;
      }
    };
  }, [visible]);

  return (
    <div className={`flex items-center gap-1`}>
      {!noicon && children}
      <div className="relative inline-block" ref={childRef}>
        {noicon ? (
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
          </div>
        ) : (
          <Button
            type="icon"
            size={size === "lg" || size === "xl" ? size : "md"}
            icon={"info"}
            color={color}
            variant="text"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            disabled={noTooltip}
          />
        )}
        {portal ? (
          createPortal(
            <AnimatePresence>
              {visible && !noTooltip && (
                <motion.div
                  ref={tooltipRef}
                  initial={{ opacity: 0, scale: 0.98 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.15 }}
                  className={`fixed pointer-events-none whitespace-nowrap px-4 py-3 rounded-md z-[9999] leading-none
            ${tooltipVariants[variant][color]}
            ${fontSizeClasses[size]}
            ${borderSizeClasses[size]}
            ${borderColorClasses[variant][color]}
          `}
                  style={{ top: -9999, left: -9999 }}
                >
                  {description}
                </motion.div>
              )}
            </AnimatePresence>,
            document.body,
          )
        ) : (
          <AnimatePresence>
            {visible && !noTooltip && (
              <motion.div
                ref={tooltipRef}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2 }}
                className={`absolute pointer-events-none whitespace-nowrap px-4 py-3 rounded-md z-50 leading-none
            ${tooltipVariants[variant][color]}
            ${fontSizeClasses[size]}
            ${borderSizeClasses[size]}
            ${borderColorClasses[variant][color]}
          `}
                style={{ top: -9999, left: -9999 }}
              >
                {description}
              </motion.div>
            )}
          </AnimatePresence>
        )}
      </div>
    </div>
  );
};

export default SmartTooltip;
